import { Task } from "@/_models/task.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnChanges } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-task-card",
    standalone: true,
    imports: [
        CommonModule,
        SharedComponentsModule,
        CombinedTaskCardMobileComponent,
        RouterModule,
    ],
    templateUrl: "./task-card.component.html",
    styleUrls: [
        "./task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class TaskCardComponent implements OnChanges {
    @Input() task: Task;
    @Input() showEdit: boolean = false;
    @Input() isLast: boolean = false;

    title: string = "Untitled Task";
    status: string = "active";
    dueDateLabel: string = "";
    totalAssociations: number = 0;

    constructor(private dateUtils: DateUtils) {}

    ngOnChanges(): void {
        if (!this.task) {
            return;
        }

        this.title = this.task.title || "Untitled Task";
        this.status = this.task.status || "active";
        this.dueDateLabel = this.task.dueDate
            ? this.dateUtils.formatDateWithConditionalYear(this.task.dueDate)
            : "";

        const flightCount = this.task.relatedFlights?.length || 0;
        const issueCount = this.task.relatedIssues?.length || 0;
        this.totalAssociations = flightCount + issueCount;
    }
}
